import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { formatErrorCode } from '../../adapters/utils/utils.adapter';
import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';
import { BookWidgetAemResponse } from '../../models/core-apis/book-widget-aem.interfaces';
import { AemService } from '../../services/aem.service';
import * as fromAemActions from '../actions/aem.actions';
import * as fromErrorHandlerActions from '../actions/error-handler.actions';
import { shouldTriggerAemApi } from '../selectors/aem.selectors';

@Injectable({ providedIn: 'root' })
export class AemEffects {
  loadBookWidgetAem$ = createEffect(
    (): Observable<Action> =>
      this.AemActions$.pipe(
        ofType(fromAemActions.LoadBookWidgetAem),
        concatLatestFrom(() => this.store.select(shouldTriggerAemApi)),
        filter(([, shouldTriggerAemApiValue]) => shouldTriggerAemApiValue),
        switchMap(() =>
          this.service.getBookWidgetAem().pipe(
            map((bookWidgetAemResponse: BookWidgetAemResponse) =>
              fromAemActions.LoadBookWidgetAemSuccess({
                bookWidgetAem: bookWidgetAemResponse.bookWidget
              })
            ),
            catchError((error: HttpErrorResponse) => {
              return of(
                fromErrorHandlerActions.HandleError({
                  errorCode: formatErrorCode(
                    BOOK_WIDGET_ERROR_CODES.AEM_FAILURE,
                    error?.status
                  ),
                  error: BOOK_WIDGET_ERROR_CODES.AEM_FAILURE
                }),
                fromAemActions.LoadBookWidgetAemFailure()
              );
            })
          )
        )
      )
  );

  constructor(
    private AemActions$: Actions,
    private service: AemService,
    private store: Store
  ) {}
}
